import { render, staticRenderFns } from "./ColorControlRow.vue?vue&type=template&id=671dfc12&scoped=true&"
import script from "./ColorControlRow.vue?vue&type=script&lang=js&"
export * from "./ColorControlRow.vue?vue&type=script&lang=js&"
import style0 from "./ColorControlRow.vue?vue&type=style&index=0&id=671dfc12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671dfc12",
  null
  
)

export default component.exports